import pug from 'javascripts/core_post_webpack/profile_helpers/file_upload.jst.pug';
window.JST = window.JST || {};
window.JST['core_post_webpack/profile_helpers/file_upload'] = pug;
